<script lang="ts">import { t, Verbiage } from "@infinitro/content";
import { getIcon } from "../data/icons";
const DiscordIcon = getIcon("DiscordIcon");
</script>

{#if typeof DiscordIcon === 'string'}
	<img src={DiscordIcon} alt={$t(Verbiage.icon_alt, 'alts')} />
{:else if typeof DiscordIcon === 'function'}
	<svelte:component this={DiscordIcon} />
{:else}
	<span>Invalid icon</span>
{/if}

<style>
</style>
